let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("flFx3")).then(() => parcelRequire('8xHcr'));